function fetchSeriesInfo(metadataId, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/bibs/${metadataId}/seriesinfo`;
  return apiClient.get(route);
}

export default {
  fetchSeriesInfo
};
